// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskDetail-module__root___nWvUV {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

.TaskDetail-module__readinessBanner___S4yJE {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.TaskDetail-module__readinessBanner___S4yJE:hover {
  background: #f4f4f5;
  border-color: #a1a1aa;
}

.TaskDetail-module__readinessBanner___S4yJE:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__readinessBannerArrow___IN5mT {
  color: #a1a1aa;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__readinessBannerBody___ui9SP {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.TaskDetail-module__readinessBannerLabel___jAM0z {
  font-size: 12px;
  font-weight: 600;
  color: #a1a1aa;
  line-height: 1.2;
}

.TaskDetail-module__readinessBannerTitle___VYCQr {
  font-size: 13px;
  font-weight: 600;
  color: #52525b;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__unclaimedBanner___Uu_dM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fefce8;
  border-top: 1px solid #fde68a;
  border-bottom: 1px solid #fde68a;
}

.TaskDetail-module__claimedBanner___Cwl0n {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__followingBanner___ljM3I {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #f0f9ff;
  border-top: 1px solid #bae6fd;
  border-bottom: 1px solid #bae6fd;
}

.TaskDetail-module__claimButtonWrap___xZgxS {
  position: relative;
  display: inline-flex;
}

.TaskDetail-module__claimNote___VlEiP {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 240px;
  padding: 6px 10px;
  border-radius: 6px;
  background: #18181b;
  color: #fafafa;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  z-index: 20;
  pointer-events: none;
}

.TaskDetail-module__claimNote___VlEiP::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #18181b;
}

.TaskDetail-module__claimNoteOk___lFDBB {
  color: #fafafa;
}

.TaskDetail-module__claimNoteOver___X8E9q {
  background: #92400e;
}

.TaskDetail-module__claimNoteOver___X8E9q::after {
  border-top-color: #92400e;
}

.TaskDetail-module__claimNoteBreach___mEaUH {
  background: #b91c1c;
}

.TaskDetail-module__claimNoteBreach___mEaUH::after {
  border-top-color: #b91c1c;
}

.TaskDetail-module__systemBanner___TFn9i {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #eff6ff;
  border-top: 1px solid #bfdbfe;
  border-bottom: 1px solid #bfdbfe;
}

.TaskDetail-module__systemBannerCopy___k9PIY {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.TaskDetail-module__systemLabel___jpnx3 {
  font-size: 12px;
  font-weight: 700;
  color: #1d4ed8;
  line-height: 1.2;
}

.TaskDetail-module__systemText___bAq0p {
  font-size: 12px;
  color: #3f3f46;
  line-height: 1.35;
}

.TaskDetail-module__capacityWarningBanner___GnEKz {
  padding: 10px 16px;
  border-bottom: 1px solid transparent;
}

.TaskDetail-module__capacityWarningBannerOver___M5iDA {
  background: #fffbeb;
  border-bottom-color: #fde68a;
}

.TaskDetail-module__capacityWarningBannerBreach___UvG7l {
  background: #fef2f2;
  border-bottom-color: #fecaca;
}

.TaskDetail-module__capacityWarningTitle___b3PV5 {
  font-size: 13px;
  font-weight: 600;
}

.TaskDetail-module__capacityWarningBannerOver___M5iDA .TaskDetail-module__capacityWarningTitle___b3PV5 {
  color: #92400e;
}

.TaskDetail-module__capacityWarningBannerBreach___UvG7l .TaskDetail-module__capacityWarningTitle___b3PV5 {
  color: #b91c1c;
}

.TaskDetail-module__capacityWarningText___MMatA {
  margin-top: 2px;
  font-size: 12px;
  color: #52525b;
  line-height: 1.4;
}

.TaskDetail-module__capacityWarningSlaText___xItDE {
  margin-top: 2px;
  font-size: 12px;
  color: #b91c1c;
  line-height: 1.4;
}

.TaskDetail-module__waitingOnSubtasksBanner___IQK2l {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 16px;
  background: #eff6ff;
  border-top: 1px solid #bfdbfe;
  border-bottom: 1px solid #bfdbfe;
}

.TaskDetail-module__allSubtasksCompletedBanner___WuTf5 {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 16px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__blockedBanner___f5Ng4 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fafafa;
  border-top: 1px solid #e4e4e7;
  border-bottom: 1px solid #e4e4e7;
}

.TaskDetail-module__completedBanner___qP_6H {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__canceledBanner___z2FX_ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #fef2f2;
  border-top: 1px solid #fecaca;
  border-bottom: 1px solid #fecaca;
}

.TaskDetail-module__unableToCompleteBanner___u20gb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #fff7ed;
  border-top: 1px solid #fed7aa;
  border-bottom: 1px solid #fed7aa;
}

.TaskDetail-module__unclaimedBannerCopy___KsOXK {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__claimedBannerCopy___nU7EE {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedBannerCopy___zX_R1 {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__waitingOnSubtasksCopy___a5RuY {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__allSubtasksCompletedCopy___stkyI {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedBannerIconWrap___Ghhy6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #a1a1aa;
}

.TaskDetail-module__waitingOnSubtasksIconWrap___rttwb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #0b79b7;
}

.TaskDetail-module__allSubtasksCompletedIconWrap___IJaZT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #166534;
}

.TaskDetail-module__blockedBannerIcon___xiAb9 {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__waitingOnSubtasksIcon___MCFcZ {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__allSubtasksCompletedIcon___tfDfM {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__unclaimedLabel___CCP_L {
  font-size: 12px;
  font-weight: 600;
  color: #a16207;
}

.TaskDetail-module__unclaimedText___clcKS {
  font-size: 10px;
  color: #a1a1aa;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__followingLabel___IgUXj {
  font-size: 12px;
  font-weight: 600;
  color: #0369a1;
}

.TaskDetail-module__claimedLabel___IKRXJ {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__claimedDot___vN0xw {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #22c55e;
  flex-shrink: 0;
}

.TaskDetail-module__blockedLabel___msHYi {
  font-size: 12px;
  font-weight: 600;
  color: #52525b;
}

.TaskDetail-module__waitingOnSubtasksLabel___wbb1Z {
  font-size: 12px;
  font-weight: 600;
  color: #0b79b7;
}

.TaskDetail-module__allSubtasksCompletedLabel___kPTJl {
  font-size: 12px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__waitingOnSubtasksText___gGjn6 {
  font-size: 10px;
  color: #0b79b7;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__allSubtasksCompletedText___uIFN1 {
  font-size: 10px;
  color: #166534;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__blockedWaitingText___M7P3z {
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.35;
  color: #a1a1aa;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__blockedWaitingLabel___Iqkdz {
  font-weight: 500;
}

.TaskDetail-module__completedLabel___EDMgd {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__canceledLabel___Nzsj5 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #b91c1c;
}

.TaskDetail-module__unableToCompleteLabel___KOaWO {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #c2410c;
}

.TaskDetail-module__completedCheck___J_qDv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-size: 12px;
  font-weight: 700;
}

.TaskDetail-module__canceledMark___W5Wni {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fee2e2;
  color: #b91c1c;
}

.TaskDetail-module__unableToCompleteMark___op5tA {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fed7aa;
  color: #c2410c;
  font-size: 12px;
  font-weight: 700;
}

.TaskDetail-module__priorityBadge___ADfFk {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.TaskDetail-module__priorityBadgecritical___JucaQ {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
  font-weight: 600;
}

.TaskDetail-module__priorityBadgehigh___jyZfd {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.TaskDetail-module__priorityBadgemedium___I6IMI {
  background: #fefce8;
  border-color: #fef08a;
  color: #a16207;
}

.TaskDetail-module__priorityBadgelow___gF1Z8 {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}

.TaskDetail-module__claimedTime___MtNCK {
  font-size: 11px;
  color: #a1a1aa;
}

.TaskDetail-module__unclaimedBannerActions___fbYRt {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TaskDetail-module__followingBannerActions___ZREd_ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TaskDetail-module__claimButton___AuLFq {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.TaskDetail-module__claimButtonBreach___Wv_CV {
  background: #ffffff;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.TaskDetail-module__followButton___YD50W {
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #0369a1;
  cursor: pointer;
}

.TaskDetail-module__unfollowButton___EIk68 {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #fafafa;
  color: #52525b;
  cursor: pointer;
}

.TaskDetail-module__claimButton___AuLFq:disabled,
.TaskDetail-module__followButton___YD50W:disabled,
.TaskDetail-module__unfollowButton___EIk68:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.TaskDetail-module__sectionHeader___uGYNw {
  padding: 14px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__headerTop___mUdWb {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.TaskDetail-module__title___H5AXp {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.35;
  padding-right: 8px;
}

.TaskDetail-module__closeButton___IrhIh {
  background: none;
  border: none;
  font-size: 16px;
  color: #a1a1aa;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.TaskDetail-module__closeButton___IrhIh:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__caption___akEbw {
  font-size: 13px;
  color: #52525b;
  line-height: 1.5;
  margin-bottom: 8px;
}

.TaskDetail-module__taskDescription___MjbIn {
  font-size: 13px;
  color: #52525b;
  line-height: 1.6;
  margin-bottom: 8px;
}

.TaskDetail-module__badgesRow___TezKK {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.TaskDetail-module__waitingStatusBadge___OAa6v {
  background: #eff6ff;
  color: #0b79b7;
  border: 1px solid #93c5fd;
}

.TaskDetail-module__sectionInfo___qfNKM {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__infoGrid___wD8HU {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 5px 0;
  font-size: 12px;
}

.TaskDetail-module__infoRow___gsytr {
  display: contents;
}

.TaskDetail-module__infoLabel___M9DCK {
  color: #a1a1aa;
  font-weight: 500;
}

.TaskDetail-module__infoValue___C5B4S {
  color: #3f3f46;
}

.TaskDetail-module__athenaLinkWrap___GbZ6E {
  margin-top: 8px;
}

.TaskDetail-module__sectionEvidence___yEDgJ {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__sectionLabel___ySsR2 {
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}

.TaskDetail-module__evidenceMetaGrid___wjM8A {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 5px 0;
  margin-bottom: 10px;
  font-size: 12px;
}

.TaskDetail-module__evidenceCard___oQa6e {
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  padding: 10px 12px;
}

.TaskDetail-module__evidenceHeader___PGN03 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
}

.TaskDetail-module__evidenceIcon___Tpi8r {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 600;
}

.TaskDetail-module__evidenceLabel___WuCSN {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #52525b;
}

.TaskDetail-module__evidenceSpacer___Jw7SR {
  flex: 1;
}

.TaskDetail-module__evidenceRef___MDKDx {
  font-family: "IBM Plex Mono", monospace;
  font-size: 9px;
  color: #a1a1aa;
}

.TaskDetail-module__evidenceSummary___ZqYQK {
  font-size: 12px;
  line-height: 1.6;
  color: #3f3f46;
  margin: 0 0 6px;
}

.TaskDetail-module__evidenceSource___d4_fe {
  font-size: 10px;
  color: #a1a1aa;
}

.TaskDetail-module__sopSection___xjbMt {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__linkedTasksSection___dPunl {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__linkedTasksHeader___GcU4c {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.TaskDetail-module__linkedTasksHeaderIcon___cQSHS {
  width: 14px;
  height: 14px;
  color: #7c3aed;
  flex-shrink: 0;
}

.TaskDetail-module__linkedTasksHeaderLabel___HpBno {
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1;
}

.TaskDetail-module__linkedTasksHeaderChevron___ojWjX {
  width: 12px;
  height: 12px;
  color: #7c3aed;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.TaskDetail-module__linkedTasksHeaderChevronExpanded___B0PeM {
  transform: rotate(90deg);
}

.TaskDetail-module__linkedTasksList___DC3Bf {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TaskDetail-module__linkedTaskRow___h0riB {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__linkedTaskRow___h0riB:hover {
  border-color: #d4d4d8;
  background: #fafafa;
}

.TaskDetail-module__linkedTaskRow___h0riB:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__linkedTaskTitle___VKwK8 {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__linkedTaskMeta___uyW1M {
  display: flex;
  align-items: center;
  gap: 6px;
}

.TaskDetail-module__linkedTaskOwner___g9CPN {
  font-size: 11px;
  color: #71717a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__linkedTaskDue___wZrH9 {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #a1a1aa;
  white-space: nowrap;
}

.TaskDetail-module__subtasksSection___hjwP6 {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__subtasksHeader___XyKeH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.TaskDetail-module__subtasksHeaderAction___MGvvj {
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  padding: 6px 10px;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1;
}

.TaskDetail-module__subtasksHeaderAction___MGvvj:hover {
  border-color: #a1a1aa;
  background: #fafafa;
  color: #27272a;
}

.TaskDetail-module__subtasksHeaderAction___MGvvj:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TaskDetail-module__subtasksList____xImD {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TaskDetail-module__subtaskRow___ACxYH {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  min-width: 0;
}

.TaskDetail-module__subtaskRow___ACxYH:hover {
  border-color: #d4d4d8;
  background: #fafafa;
}

.TaskDetail-module__subtaskRow___ACxYH:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1 {
  border-color: #bbf7d0;
  border-left: 2px solid #86efac;
  background: #f0fdf4;
  padding-left: 8px;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1:hover {
  border-color: #86efac;
  background: #f0fdf4;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC {
  border-color: #fecaca;
  border-left: 2px solid #f87171;
  background: #fef2f2;
  padding-left: 8px;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC:hover {
  border-color: #f87171;
  background: #fef2f2;
}

.TaskDetail-module__subtaskStatusDot___DFKGh {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #f59e0b;
  flex-shrink: 0;
}

.TaskDetail-module__subtaskStatusDotCompleted___fajup {
  background: #22c55e;
}

.TaskDetail-module__subtaskStatusDotCanceled____gQnD {
  background: #ef4444;
}

.TaskDetail-module__subtaskRowPrimary___nSYfm {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.TaskDetail-module__subtaskTitle___jFauS {
  display: block;
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__subtaskTitleCompleted___GDBuI {
  color: #166534;
  text-decoration: line-through;
}

.TaskDetail-module__subtaskTitleCanceled___d6ibn {
  color: #b91c1c;
  text-decoration: line-through;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1 .TaskDetail-module__subtaskMeta___Lp3DD,
.TaskDetail-module__subtaskRowCompleted___uzJd1 .TaskDetail-module__subtaskDue___MgjVl {
  color: #166534;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1 .TaskDetail-module__subtaskTeamIcon___xb1IZ {
  background: #dcfce7;
  border-color: #86efac;
  color: #166534;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC .TaskDetail-module__subtaskMeta___Lp3DD,
.TaskDetail-module__subtaskRowCanceled___q0LFC .TaskDetail-module__subtaskDue___MgjVl {
  color: #b91c1c;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC .TaskDetail-module__subtaskTeamIcon___xb1IZ {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.TaskDetail-module__subtaskRowMeta___DRJ9D {
  min-width: 0;
  width: 132px;
  flex: 0 0 132px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
}

.TaskDetail-module__subtaskTeamWrap___eRzKd {
  min-width: 0;
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  overflow: hidden;
}

.TaskDetail-module__subtaskTeamIcon___xb1IZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #b45309;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  flex-shrink: 0;
}

.TaskDetail-module__subtaskMeta___Lp3DD {
  min-width: 0;
  font-size: 11px;
  color: #71717a;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__subtaskDue___MgjVl {
  flex: 0 0 70px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #a1a1aa;
  text-align: right;
}

.TaskDetail-module__subtaskDueUrgent___caCtc {
  color: #b91c1c;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  flex: 0 0 24px;
  border-radius: 4px;
  background: transparent;
  color: #a1a1aa;
  cursor: pointer;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU:hover:not(:disabled) {
  background: #f4f4f5;
  color: #71717a;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__subtaskTrashButtonDisabled___HYGH2 {
  cursor: default;
  opacity: 0.45;
}

.TaskDetail-module__sopButton___y6ipC {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #18181b;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__sopButton___y6ipC:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #f4f4f5;
}

.TaskDetail-module__sopButton___y6ipC:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__sopButtonDisabled___Pa2Jv {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__sopButtonIcon___HDtLX {
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__sopButtonLabel___DttCU {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
}

.TaskDetail-module__sopButtonArrow____jQJE {
  font-size: 13px;
  color: #a1a1aa;
  flex-shrink: 0;
}

.TaskDetail-module__parentTaskSection___lbLaX {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__parentTaskCard___NPVLb {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__parentTaskCard___NPVLb:hover {
  border-color: #d4d4d8;
  background: #f4f4f5;
}

.TaskDetail-module__parentTaskCard___NPVLb:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__parentTaskIconWrap___XnChB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #9ca3af;
}

.TaskDetail-module__parentTaskIcon___hB4nN {
  width: 14px;
  height: 14px;
  stroke-width: 1.8;
}

.TaskDetail-module__parentTaskCopy___EUGMt {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.TaskDetail-module__parentTaskTitle___sl_Fv {
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.35;
}

.TaskDetail-module__parentTaskSummary___EUcvU {
  font-size: 11px;
  color: #71717a;
  line-height: 1.45;
}

.TaskDetail-module__parentTaskMeta___QooHR {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: #a1a1aa;
  line-height: 1.35;
}

.TaskDetail-module__parentTaskOwnerWrap___doTjs {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.TaskDetail-module__parentTaskOwnerBadge___B6Vn1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #52525b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__parentTaskArrow___o1i1P {
  width: 14px;
  height: 14px;
  color: #a1a1aa;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskDetail-module__assessmentSection___TsgVY {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__assessmentBadgesRow____zg6h {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
}

.TaskDetail-module__assessmentTypeBadge___hhPMT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 8px;
  border: 1px solid #c4b5fd;
  border-radius: 4px;
  background: #f3e8ff;
  color: #6d28d9;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.TaskDetail-module__assessmentVariantBadge___xhBx9 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 8px;
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #ffffff;
  color: #3f3f46;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.TaskDetail-module__caregiverAssistedBadge___JNE5l {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 8px;
  border: 1px solid #fde68a;
  border-radius: 4px;
  background: #fffbeb;
  color: #92400e;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.TaskDetail-module__assessmentButton___fre_O {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #18181b;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__assessmentButton___fre_O:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #f4f4f5;
}

.TaskDetail-module__assessmentButton___fre_O:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__assessmentButtonDisabled___YPr_a {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__assessmentButtonIcon___tNO_n {
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__assessmentButtonLabel___JIgZA {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
}

.TaskDetail-module__assessmentButtonArrow___iEAfK {
  font-size: 13px;
  color: #a1a1aa;
  flex-shrink: 0;
}

.TaskDetail-module__sectionActions___bZ0yQ {
  display: flex;
  flex-direction: column;
}

.TaskDetail-module__primaryActionSection___EPr5z {
  padding: 12px 16px;
  background: #ffffff;
}

.TaskDetail-module__primaryActionsRow___CrIgJ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 6px;
}

.TaskDetail-module__decisionActionsRow___MIayQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: 6px;
}

.TaskDetail-module__secondaryActionSection___bUWVZ {
  padding: 12px 16px;
  background: #fafafa;
  border-top: 1px solid #f4f4f5;
}

.TaskDetail-module__secondaryActionSectionStandalone___M9mT1 {
  border-top: none;
}

.TaskDetail-module__cancelReasonPanel___c_Wby {
  margin-top: 8px;
}

.TaskDetail-module__cancelReasonInput___JYV3l {
  width: 100%;
  min-height: 72px;
  resize: vertical;
  padding: 8px 10px;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.4;
  color: #27272a;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
}

.TaskDetail-module__cancelReasonInput___JYV3l:focus {
  outline: 2px solid #a1a1aa;
  outline-offset: 1px;
}

.TaskDetail-module__cancelActionRow___Y17p5 {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.TaskDetail-module__cancelTaskAction___hzd73 {
  color: #991b1b;
  border-color: #fecaca;
}

.TaskDetail-module__cancelTaskAction___hzd73:hover,
.TaskDetail-module__cancelTaskAction___hzd73:focus-visible {
  background: #fef2f2;
}

.TaskDetail-module__cancelTaskAction___hzd73:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.TaskDetail-module__primaryAction___jWo7M {
  width: 100%;
  padding: 8px 0;
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.TaskDetail-module__primaryAction___jWo7M:disabled,
.TaskDetail-module__assessmentCompleteAction___WMNjw:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__blockedIndicatorAction___xPvsF {
  grid-column: 1/-1;
  background: #f4f4f5;
  color: #a1a1aa;
  border: 1px solid #e4e4e7;
}

.TaskDetail-module__blockedIndicatorAction___xPvsF:disabled {
  cursor: not-allowed;
  opacity: 1;
}

.TaskDetail-module__cancelTaskAction___hzd73.TaskDetail-module__cancelTaskActionFullWidth___iW1Rp {
  grid-column: 1/-1;
  width: 100%;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: #dc2626;
  border-color: #dc2626;
}

.TaskDetail-module__cancelTaskAction___hzd73.TaskDetail-module__cancelTaskActionFullWidth___iW1Rp:hover,
.TaskDetail-module__cancelTaskAction___hzd73.TaskDetail-module__cancelTaskActionFullWidth___iW1Rp:focus-visible {
  background: #b91c1c;
  border-color: #b91c1c;
}

.TaskDetail-module__primaryAction___jWo7M:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__assessmentCompleteAction___WMNjw {
  width: 100%;
  padding: 8px 0;
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__assessmentCompleteAction___WMNjw:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__secondaryAction___Q7h19 {
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__secondaryActionsRow___akDaS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: nowrap;
}

.TaskDetail-module__secondaryActionsRowClaimed___BSDTH {
  align-items: flex-start;
  flex-direction: column;
}

.TaskDetail-module__secondaryActionsGroup___yIeXB {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.TaskDetail-module__secondaryActionsStatusGroupClaimed___VdKae {
  width: 100%;
}

.TaskDetail-module__statusActionWrap___q688q {
  position: relative;
}

.TaskDetail-module__secondaryAction___Q7h19:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

@media (max-width: 720px) {
  .TaskDetail-module__secondaryActionsRow___akDaS {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .TaskDetail-module__secondaryActionsGroup___yIeXB {
    width: 100%;
    flex-wrap: wrap;
  }
}
.TaskDetail-module__blockDropdown___TAMqT {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  width: 200px;
  padding: 4px 0;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);
  z-index: 10;
}

.TaskDetail-module__blockDropdownItem___x6C2y {
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: #52525b;
  font-size: 14px;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
}

.TaskDetail-module__blockDropdownItem___x6C2y:hover,
.TaskDetail-module__blockDropdownItem___x6C2y:focus-visible {
  background: #fafafa;
  outline: none;
}

.TaskDetail-module__escalateDropdown___eSL46 {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  width: 240px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);
  z-index: 10;
}

.TaskDetail-module__escalateDropdownLabel___LMItM {
  margin-bottom: 6px;
  color: #71717a;
  font-size: 12px;
  font-weight: 600;
}

.TaskDetail-module__escalateTargetOptions___OwQN3 {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}

.TaskDetail-module__escalateTargetOption___GPXS3 {
  padding: 6px 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.TaskDetail-module__escalateTargetOption___GPXS3:hover,
.TaskDetail-module__escalateTargetOption___GPXS3:focus-visible {
  background: #fafafa;
  outline: none;
}

.TaskDetail-module__escalateTargetOptionActive___K94Li {
  background: #ffffff;
  border-color: #18181b;
  color: #18181b;
  font-weight: 600;
}

.TaskDetail-module__escalateReasonInput___aFuAN {
  width: 100%;
  margin-bottom: 10px;
  padding: 8px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  color: #18181b;
  font-size: 14px;
}

.TaskDetail-module__escalateReasonInput___aFuAN:focus {
  border-color: #f59e0b;
  outline: none;
}

.TaskDetail-module__escalateSubmitButton___XjcI5 {
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: #fbbf24;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.TaskDetail-module__escalateSubmitButton___XjcI5:hover,
.TaskDetail-module__escalateSubmitButton___XjcI5:focus-visible {
  background: #f59e0b;
  outline: none;
}

.TaskDetail-module__escalateSubmitButton___XjcI5:disabled {
  background: #fcd34d;
  cursor: not-allowed;
}

.TaskDetail-module__alertAction___R0zuF {
  padding: 4px 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  cursor: pointer;
}
.TaskDetail-module__alertAction___R0zuF:hover:not(:disabled) {
  border-color: #a1a1aa;
}
.TaskDetail-module__alertAction___R0zuF:disabled {
  opacity: 0.5;
  cursor: default;
}

.TaskDetail-module__statusActionLabel____Cpk6 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TaskDetail/TaskDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AAAJ;;AAIA;EACE,mBAAA;EACA,qBAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,kBAAA;EACA,oBAAA;AADF;;AAIA;EACE,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,oBAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AADF;;AAIA;EACE,kBAAA;EACA,oCAAA;AADF;;AAIA;EACE,mBAAA;EACA,4BAAA;AADF;;AAIA;EACE,mBAAA;EACA,4BAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;;;EAGE,mBAAA;EACA,aAAA;AADF;;AAIA;EACE,kBAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AADF;;AAIA;EACE,kBAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,+BAAA;EACA,UAAA;EACA,eAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,gCAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,+BAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AADF;;AAIA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AADF;;AAIA;EACE,OAAA;AADF;;AAIA;EACE,uCAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,gCAAA;AADF;;AAIA;EACE,kBAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,gCAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AAFJ;;AAMA;EACE,qBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHF;;AAMA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;EAEF,YAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;AALF;;AAQA;EACE,0BAAA;EACA,mBAAA;AALF;;AAQA;EACE,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;AALF;;AAQA;EACE,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;AALF;;AAQA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,cAAA;EACA,6BAAA;AALF;;AAQA;EACE,cAAA;EACA,6BAAA;AALF;;AAQA;;EAEE,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AALF;;AAQA;;EAEE,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AALF;;AAQA;EACE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,cAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,0BAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,aAAA;AALF;;AAQA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AANJ;;AAUA;EACE,qBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,mBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AARJ;;AAYA;EACE,qBAAA;EACA,mBAAA;AATF;;AAYA;EACE,0BAAA;EACA,mBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AATF;;AAYA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AATF;;AAYA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,kBAAA;EACA,gCAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AATF;;AAYA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AAVJ;;AAcA;EACE,qBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,0BAAA;EACA,mBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,YAAA;AAXF;;AAcA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAXF;;AAcA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,2DAAA;EACA,QAAA;AAXF;;AAcA;EACE,aAAA;EACA,0DAAA;EACA,QAAA;AAXF;;AAcA;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,0BAAA;EACA,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAXF;;AAcA;EACE,cAAA;EACA,qBAAA;AAXF;;AAcA;;EAEE,mBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,aAAA;AAXF;;AAcA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAXF;;AAcA;;EAEE,mBAAA;EACA,YAAA;AAXF;;AAcA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,UAAA;AAXF;;AAcA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AAXF;;AAcA;;EAEE,mBAAA;EACA,qBAAA;AAXF;;AAcA;EACE,0BAAA;EACA,mBAAA;AAXF;;AAcA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAXF;;AAcA;EACE,0BAAA;EACA,mBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;AAXF;;AAcA;EACE,uBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,0BAAA;EACA,mBAAA;AAXF;;AAcA;EACE;IACE,uBAAA;IACA,eAAA;EAXF;EAcA;IACE,WAAA;IACA,eAAA;EAZF;AACF;AAaC;EACC,kBAAA;EACA,OAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AAXF;;AAcA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAXF;;AAcA;;EAEE,mBAAA;EACA,aAAA;AAXF;;AAcA;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AAXF;;AAcA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAXF;;AAcA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kFACE;AAZJ;;AAiBA;;EAEE,mBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAdF;;AAiBA;EACE,qBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAdF;;AAiBA;;EAEE,mBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAdF;AAgBE;EACE,qBAAA;AAdJ;AAiBE;EACE,YAAA;EACA,eAAA;AAfJ;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAhBF","sourcesContent":[".root {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.readinessBanner {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.readinessBanner:hover {\n  background: #f4f4f5;\n  border-color: #a1a1aa;\n}\n\n.readinessBanner:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.readinessBannerArrow {\n  color: #a1a1aa;\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.readinessBannerBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.readinessBannerLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #a1a1aa;\n  line-height: 1.2;\n}\n\n.readinessBannerTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #52525b;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.unclaimedBanner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fefce8;\n  border-top: 1px solid #fde68a;\n  border-bottom: 1px solid #fde68a;\n}\n\n.claimedBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.followingBanner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f0f9ff;\n  border-top: 1px solid #bae6fd;\n  border-bottom: 1px solid #bae6fd;\n}\n\n.claimButtonWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.claimNote {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: max-content;\n  max-width: 240px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  background: #18181b;\n  color: #fafafa;\n  font-size: 11px;\n  line-height: 1.4;\n  text-align: center;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n  z-index: 20;\n  pointer-events: none;\n}\n\n.claimNote::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #18181b;\n}\n\n.claimNoteOk {\n  color: #fafafa;\n}\n\n.claimNoteOver {\n  background: #92400e;\n}\n\n.claimNoteOver::after {\n  border-top-color: #92400e;\n}\n\n.claimNoteBreach {\n  background: #b91c1c;\n}\n\n.claimNoteBreach::after {\n  border-top-color: #b91c1c;\n}\n\n.systemBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #eff6ff;\n  border-top: 1px solid #bfdbfe;\n  border-bottom: 1px solid #bfdbfe;\n}\n\n.systemBannerCopy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.systemLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1d4ed8;\n  line-height: 1.2;\n}\n\n.systemText {\n  font-size: 12px;\n  color: #3f3f46;\n  line-height: 1.35;\n}\n\n.capacityWarningBanner {\n  padding: 10px 16px;\n  border-bottom: 1px solid transparent;\n}\n\n.capacityWarningBannerOver {\n  background: #fffbeb;\n  border-bottom-color: #fde68a;\n}\n\n.capacityWarningBannerBreach {\n  background: #fef2f2;\n  border-bottom-color: #fecaca;\n}\n\n.capacityWarningTitle {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.capacityWarningBannerOver .capacityWarningTitle {\n  color: #92400e;\n}\n\n.capacityWarningBannerBreach .capacityWarningTitle {\n  color: #b91c1c;\n}\n\n.capacityWarningText {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #52525b;\n  line-height: 1.4;\n}\n\n.capacityWarningSlaText {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #b91c1c;\n  line-height: 1.4;\n}\n\n.waitingOnSubtasksBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #eff6ff;\n  border-top: 1px solid #bfdbfe;\n  border-bottom: 1px solid #bfdbfe;\n}\n\n.allSubtasksCompletedBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.blockedBanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fafafa;\n  border-top: 1px solid #e4e4e7;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.completedBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.canceledBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fef2f2;\n  border-top: 1px solid #fecaca;\n  border-bottom: 1px solid #fecaca;\n}\n\n.unableToCompleteBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fff7ed;\n  border-top: 1px solid #fed7aa;\n  border-bottom: 1px solid #fed7aa;\n}\n\n.unclaimedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.claimedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.waitingOnSubtasksCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.allSubtasksCompletedCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedBannerIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #a1a1aa;\n}\n\n.waitingOnSubtasksIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #0b79b7;\n}\n\n.allSubtasksCompletedIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #166534;\n}\n\n.blockedBannerIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.waitingOnSubtasksIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.allSubtasksCompletedIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.unclaimedLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #a16207;\n}\n\n.unclaimedText {\n  font-size: 10px;\n  color: #a1a1aa;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.followingLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0369a1;\n}\n\n.claimedLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.claimedDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #22c55e;\n  flex-shrink: 0;\n}\n\n.blockedLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.waitingOnSubtasksLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0b79b7;\n}\n\n.allSubtasksCompletedLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.waitingOnSubtasksText {\n  font-size: 10px;\n  color: #0b79b7;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.allSubtasksCompletedText {\n  font-size: 10px;\n  color: #166534;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.blockedWaitingText {\n  margin-top: 2px;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #a1a1aa;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.blockedWaitingLabel {\n  font-weight: 500;\n}\n\n.completedLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.canceledLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #b91c1c;\n}\n\n.unableToCompleteLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #c2410c;\n}\n\n.completedCheck {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #166534;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.canceledMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.unableToCompleteMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fed7aa;\n  color: #c2410c;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.priorityBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.priorityBadgecritical {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.priorityBadgehigh {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.priorityBadgemedium {\n  background: #fefce8;\n  border-color: #fef08a;\n  color: #a16207;\n}\n\n.priorityBadgelow {\n  background: #f9fafb;\n  border-color: #e5e7eb;\n  color: #6b7280;\n}\n\n.claimedTime {\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.unclaimedBannerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.followingBannerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.claimButton {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.claimButtonBreach {\n  background: #ffffff;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.followButton {\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #0369a1;\n  cursor: pointer;\n}\n\n.unfollowButton {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #fafafa;\n  color: #52525b;\n  cursor: pointer;\n}\n\n.claimButton:disabled,\n.followButton:disabled,\n.unfollowButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.sectionHeader {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.headerTop {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 4px;\n}\n\n.title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.35;\n  padding-right: 8px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: #a1a1aa;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.closeButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.caption {\n  font-size: 13px;\n  color: #52525b;\n  line-height: 1.5;\n  margin-bottom: 8px;\n}\n\n.taskDescription {\n  font-size: 13px;\n  color: #52525b;\n  line-height: 1.6;\n  margin-bottom: 8px;\n}\n\n.badgesRow {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.waitingStatusBadge {\n  background: #eff6ff;\n  color: #0b79b7;\n  border: 1px solid #93c5fd;\n}\n\n.sectionInfo {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 5px 0;\n  font-size: 12px;\n}\n\n.infoRow {\n  display: contents;\n}\n\n.infoLabel {\n  color: #a1a1aa;\n  font-weight: 500;\n}\n\n.infoValue {\n  color: #3f3f46;\n}\n\n.athenaLinkWrap {\n  margin-top: 8px;\n}\n\n.sectionEvidence {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.sectionLabel {\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 6px;\n}\n\n.evidenceMetaGrid {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 5px 0;\n  margin-bottom: 10px;\n  font-size: 12px;\n}\n\n.evidenceCard {\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.evidenceHeader {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 5px;\n}\n\n.evidenceIcon {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.evidenceLabel {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #52525b;\n}\n\n.evidenceSpacer {\n  flex: 1;\n}\n\n.evidenceRef {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 9px;\n  color: #a1a1aa;\n}\n\n.evidenceSummary {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #3f3f46;\n  margin: 0 0 6px;\n}\n\n.evidenceSource {\n  font-size: 10px;\n  color: #a1a1aa;\n}\n\n.sopSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.linkedTasksSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.linkedTasksHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.linkedTasksHeaderIcon {\n  width: 14px;\n  height: 14px;\n  color: #7c3aed;\n  flex-shrink: 0;\n}\n\n.linkedTasksHeaderLabel {\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1;\n}\n\n.linkedTasksHeaderChevron {\n  width: 12px;\n  height: 12px;\n  color: #7c3aed;\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n\n.linkedTasksHeaderChevronExpanded {\n  transform: rotate(90deg);\n}\n\n.linkedTasksList {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.linkedTaskRow {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.linkedTaskRow:hover {\n  border-color: #d4d4d8;\n  background: #fafafa;\n}\n\n.linkedTaskRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.linkedTaskTitle {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.linkedTaskMeta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.linkedTaskOwner {\n  font-size: 11px;\n  color: #71717a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.linkedTaskDue {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.subtasksSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.subtasksHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.subtasksHeaderAction {\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  padding: 6px 10px;\n  color: #52525b;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.subtasksHeaderAction:hover {\n  border-color: #a1a1aa;\n  background: #fafafa;\n  color: #27272a;\n}\n\n.subtasksHeaderAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.subtasksList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.subtaskRow {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n  min-width: 0;\n}\n\n.subtaskRow:hover {\n  border-color: #d4d4d8;\n  background: #fafafa;\n}\n\n.subtaskRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.subtaskRowCompleted {\n  border-color: #bbf7d0;\n  border-left: 2px solid #86efac;\n  background: #f0fdf4;\n  padding-left: 8px;\n}\n\n.subtaskRowCompleted:hover {\n  border-color: #86efac;\n  background: #f0fdf4;\n}\n\n.subtaskRowCanceled {\n  border-color: #fecaca;\n  border-left: 2px solid #f87171;\n  background: #fef2f2;\n  padding-left: 8px;\n}\n\n.subtaskRowCanceled:hover {\n  border-color: #f87171;\n  background: #fef2f2;\n}\n\n.subtaskStatusDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #f59e0b;\n  flex-shrink: 0;\n}\n\n.subtaskStatusDotCompleted {\n  background: #22c55e;\n}\n\n.subtaskStatusDotCanceled {\n  background: #ef4444;\n}\n\n.subtaskRowPrimary {\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.subtaskTitle {\n  display: block;\n  width: 100%;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtaskTitleCompleted {\n  color: #166534;\n  text-decoration: line-through;\n}\n\n.subtaskTitleCanceled {\n  color: #b91c1c;\n  text-decoration: line-through;\n}\n\n.subtaskRowCompleted .subtaskMeta,\n.subtaskRowCompleted .subtaskDue {\n  color: #166534;\n}\n\n.subtaskRowCompleted .subtaskTeamIcon {\n  background: #dcfce7;\n  border-color: #86efac;\n  color: #166534;\n}\n\n.subtaskRowCanceled .subtaskMeta,\n.subtaskRowCanceled .subtaskDue {\n  color: #b91c1c;\n}\n\n.subtaskRowCanceled .subtaskTeamIcon {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.subtaskRowMeta {\n  min-width: 0;\n  width: 132px;\n  flex: 0 0 132px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.subtaskTeamWrap {\n  min-width: 0;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.subtaskTeamIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  color: #b45309;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.subtaskMeta {\n  min-width: 0;\n  font-size: 11px;\n  color: #71717a;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtaskDue {\n  flex: 0 0 70px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #a1a1aa;\n  text-align: right;\n}\n\n.subtaskDueUrgent {\n  color: #b91c1c;\n}\n\n.subtaskTrashButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  flex: 0 0 24px;\n  border-radius: 4px;\n  background: transparent;\n  color: #a1a1aa;\n  cursor: pointer;\n}\n\n.subtaskTrashButton:hover:not(:disabled) {\n  background: #f4f4f5;\n  color: #71717a;\n}\n\n.subtaskTrashButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.subtaskTrashButtonDisabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.sopButton {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  color: #18181b;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.sopButton:hover:not(:disabled) {\n  border-color: #d4d4d8;\n  background: #f4f4f5;\n}\n\n.sopButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.sopButtonDisabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.sopButtonIcon {\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.sopButtonLabel {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.sopButtonArrow {\n  font-size: 13px;\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.parentTaskSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.parentTaskCard {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #fafafa;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.parentTaskCard:hover {\n  border-color: #d4d4d8;\n  background: #f4f4f5;\n}\n\n.parentTaskCard:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.parentTaskIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  color: #9ca3af;\n}\n\n.parentTaskIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 1.8;\n}\n\n.parentTaskCopy {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.parentTaskTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.35;\n}\n\n.parentTaskSummary {\n  font-size: 11px;\n  color: #71717a;\n  line-height: 1.45;\n}\n\n.parentTaskMeta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 11px;\n  color: #a1a1aa;\n  line-height: 1.35;\n}\n\n.parentTaskOwnerWrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.parentTaskOwnerBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  color: #52525b;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.parentTaskArrow {\n  width: 14px;\n  height: 14px;\n  color: #a1a1aa;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.assessmentSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.assessmentBadgesRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.assessmentTypeBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 3px 8px;\n  border: 1px solid #c4b5fd;\n  border-radius: 4px;\n  background: #f3e8ff;\n  color: #6d28d9;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.assessmentVariantBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 3px 8px;\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #3f3f46;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.caregiverAssistedBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 3px 8px;\n  border: 1px solid #fde68a;\n  border-radius: 4px;\n  background: #fffbeb;\n  color: #92400e;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.assessmentButton {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  color: #18181b;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.assessmentButton:hover:not(:disabled) {\n  border-color: #d4d4d8;\n  background: #f4f4f5;\n}\n\n.assessmentButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.assessmentButtonDisabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.assessmentButtonIcon {\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.assessmentButtonLabel {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.assessmentButtonArrow {\n  font-size: 13px;\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.sectionActions {\n  display: flex;\n  flex-direction: column;\n}\n\n.primaryActionSection {\n  padding: 12px 16px;\n  background: #ffffff;\n}\n\n.primaryActionsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 6px;\n}\n\n.decisionActionsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));\n  gap: 6px;\n}\n\n.secondaryActionSection {\n  padding: 12px 16px;\n  background: #fafafa;\n  border-top: 1px solid #f4f4f5;\n}\n\n.secondaryActionSectionStandalone {\n  border-top: none;\n}\n\n.cancelReasonPanel {\n  margin-top: 8px;\n}\n\n.cancelReasonInput {\n  width: 100%;\n  min-height: 72px;\n  resize: vertical;\n  padding: 8px 10px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #27272a;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n}\n\n.cancelReasonInput:focus {\n  outline: 2px solid #a1a1aa;\n  outline-offset: 1px;\n}\n\n.cancelActionRow {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.cancelTaskAction {\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.cancelTaskAction:hover,\n.cancelTaskAction:focus-visible {\n  background: #fef2f2;\n}\n\n.cancelTaskAction:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.primaryAction {\n  width: 100%;\n  padding: 8px 0;\n  margin-bottom: 2px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.primaryAction:disabled,\n.assessmentCompleteAction:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.blockedIndicatorAction {\n  grid-column: 1 / -1;\n  background: #f4f4f5;\n  color: #a1a1aa;\n  border: 1px solid #e4e4e7;\n}\n\n.blockedIndicatorAction:disabled {\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.cancelTaskAction.cancelTaskActionFullWidth {\n  grid-column: 1 / -1;\n  width: 100%;\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n.cancelTaskAction.cancelTaskActionFullWidth:hover,\n.cancelTaskAction.cancelTaskActionFullWidth:focus-visible {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.primaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.assessmentCompleteAction {\n  width: 100%;\n  padding: 8px 0;\n  margin-bottom: 2px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.assessmentCompleteAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.secondaryAction {\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.secondaryActionsRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.secondaryActionsRowClaimed {\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.secondaryActionsGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.secondaryActionsStatusGroupClaimed {\n  width: 100%;\n}\n\n.statusActionWrap {\n  position: relative;\n}\n\n.secondaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n@media (max-width: 720px) {\n  .secondaryActionsRow {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .secondaryActionsGroup {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}.blockDropdown {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 8px);\n  width: 200px;\n  padding: 4px 0;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);\n  z-index: 10;\n}\n\n.blockDropdownItem {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  color: #52525b;\n  font-size: 14px;\n  line-height: 1.2;\n  text-align: left;\n  cursor: pointer;\n}\n\n.blockDropdownItem:hover,\n.blockDropdownItem:focus-visible {\n  background: #fafafa;\n  outline: none;\n}\n\n.escalateDropdown {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 8px);\n  width: 240px;\n  padding: 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);\n  z-index: 10;\n}\n\n.escalateDropdownLabel {\n  margin-bottom: 6px;\n  color: #71717a;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.escalateTargetOptions {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.escalateTargetOption {\n  padding: 6px 8px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #52525b;\n  font-size: 12px;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.escalateTargetOption:hover,\n.escalateTargetOption:focus-visible {\n  background: #fafafa;\n  outline: none;\n}\n\n.escalateTargetOptionActive {\n  background: #ffffff;\n  border-color: #18181b;\n  color: #18181b;\n  font-weight: 600;\n}\n\n.escalateReasonInput {\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 8px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  color: #18181b;\n  font-size: 14px;\n}\n\n.escalateReasonInput:focus {\n  border-color: #f59e0b;\n  outline: none;\n}\n\n.escalateSubmitButton {\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: #fbbf24;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.escalateSubmitButton:hover,\n.escalateSubmitButton:focus-visible {\n  background: #f59e0b;\n  outline: none;\n}\n\n.escalateSubmitButton:disabled {\n  background: #fcd34d;\n  cursor: not-allowed;\n}\n\n.alertAction {\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #a1a1aa;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.statusActionLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TaskDetail-module__root___nWvUV`,
	"readinessBanner": `TaskDetail-module__readinessBanner___S4yJE`,
	"readinessBannerArrow": `TaskDetail-module__readinessBannerArrow___IN5mT`,
	"readinessBannerBody": `TaskDetail-module__readinessBannerBody___ui9SP`,
	"readinessBannerLabel": `TaskDetail-module__readinessBannerLabel___jAM0z`,
	"readinessBannerTitle": `TaskDetail-module__readinessBannerTitle___VYCQr`,
	"unclaimedBanner": `TaskDetail-module__unclaimedBanner___Uu_dM`,
	"claimedBanner": `TaskDetail-module__claimedBanner___Cwl0n`,
	"followingBanner": `TaskDetail-module__followingBanner___ljM3I`,
	"claimButtonWrap": `TaskDetail-module__claimButtonWrap___xZgxS`,
	"claimNote": `TaskDetail-module__claimNote___VlEiP`,
	"claimNoteOk": `TaskDetail-module__claimNoteOk___lFDBB`,
	"claimNoteOver": `TaskDetail-module__claimNoteOver___X8E9q`,
	"claimNoteBreach": `TaskDetail-module__claimNoteBreach___mEaUH`,
	"systemBanner": `TaskDetail-module__systemBanner___TFn9i`,
	"systemBannerCopy": `TaskDetail-module__systemBannerCopy___k9PIY`,
	"systemLabel": `TaskDetail-module__systemLabel___jpnx3`,
	"systemText": `TaskDetail-module__systemText___bAq0p`,
	"capacityWarningBanner": `TaskDetail-module__capacityWarningBanner___GnEKz`,
	"capacityWarningBannerOver": `TaskDetail-module__capacityWarningBannerOver___M5iDA`,
	"capacityWarningBannerBreach": `TaskDetail-module__capacityWarningBannerBreach___UvG7l`,
	"capacityWarningTitle": `TaskDetail-module__capacityWarningTitle___b3PV5`,
	"capacityWarningText": `TaskDetail-module__capacityWarningText___MMatA`,
	"capacityWarningSlaText": `TaskDetail-module__capacityWarningSlaText___xItDE`,
	"waitingOnSubtasksBanner": `TaskDetail-module__waitingOnSubtasksBanner___IQK2l`,
	"allSubtasksCompletedBanner": `TaskDetail-module__allSubtasksCompletedBanner___WuTf5`,
	"blockedBanner": `TaskDetail-module__blockedBanner___f5Ng4`,
	"completedBanner": `TaskDetail-module__completedBanner___qP_6H`,
	"canceledBanner": `TaskDetail-module__canceledBanner___z2FX_`,
	"unableToCompleteBanner": `TaskDetail-module__unableToCompleteBanner___u20gb`,
	"unclaimedBannerCopy": `TaskDetail-module__unclaimedBannerCopy___KsOXK`,
	"claimedBannerCopy": `TaskDetail-module__claimedBannerCopy___nU7EE`,
	"blockedBannerCopy": `TaskDetail-module__blockedBannerCopy___zX_R1`,
	"waitingOnSubtasksCopy": `TaskDetail-module__waitingOnSubtasksCopy___a5RuY`,
	"allSubtasksCompletedCopy": `TaskDetail-module__allSubtasksCompletedCopy___stkyI`,
	"blockedBannerIconWrap": `TaskDetail-module__blockedBannerIconWrap___Ghhy6`,
	"waitingOnSubtasksIconWrap": `TaskDetail-module__waitingOnSubtasksIconWrap___rttwb`,
	"allSubtasksCompletedIconWrap": `TaskDetail-module__allSubtasksCompletedIconWrap___IJaZT`,
	"blockedBannerIcon": `TaskDetail-module__blockedBannerIcon___xiAb9`,
	"waitingOnSubtasksIcon": `TaskDetail-module__waitingOnSubtasksIcon___MCFcZ`,
	"allSubtasksCompletedIcon": `TaskDetail-module__allSubtasksCompletedIcon___tfDfM`,
	"unclaimedLabel": `TaskDetail-module__unclaimedLabel___CCP_L`,
	"unclaimedText": `TaskDetail-module__unclaimedText___clcKS`,
	"followingLabel": `TaskDetail-module__followingLabel___IgUXj`,
	"claimedLabel": `TaskDetail-module__claimedLabel___IKRXJ`,
	"claimedDot": `TaskDetail-module__claimedDot___vN0xw`,
	"blockedLabel": `TaskDetail-module__blockedLabel___msHYi`,
	"waitingOnSubtasksLabel": `TaskDetail-module__waitingOnSubtasksLabel___wbb1Z`,
	"allSubtasksCompletedLabel": `TaskDetail-module__allSubtasksCompletedLabel___kPTJl`,
	"waitingOnSubtasksText": `TaskDetail-module__waitingOnSubtasksText___gGjn6`,
	"allSubtasksCompletedText": `TaskDetail-module__allSubtasksCompletedText___uIFN1`,
	"blockedWaitingText": `TaskDetail-module__blockedWaitingText___M7P3z`,
	"blockedWaitingLabel": `TaskDetail-module__blockedWaitingLabel___Iqkdz`,
	"completedLabel": `TaskDetail-module__completedLabel___EDMgd`,
	"canceledLabel": `TaskDetail-module__canceledLabel___Nzsj5`,
	"unableToCompleteLabel": `TaskDetail-module__unableToCompleteLabel___KOaWO`,
	"completedCheck": `TaskDetail-module__completedCheck___J_qDv`,
	"canceledMark": `TaskDetail-module__canceledMark___W5Wni`,
	"unableToCompleteMark": `TaskDetail-module__unableToCompleteMark___op5tA`,
	"priorityBadge": `TaskDetail-module__priorityBadge___ADfFk`,
	"priorityBadgecritical": `TaskDetail-module__priorityBadgecritical___JucaQ`,
	"priorityBadgehigh": `TaskDetail-module__priorityBadgehigh___jyZfd`,
	"priorityBadgemedium": `TaskDetail-module__priorityBadgemedium___I6IMI`,
	"priorityBadgelow": `TaskDetail-module__priorityBadgelow___gF1Z8`,
	"claimedTime": `TaskDetail-module__claimedTime___MtNCK`,
	"unclaimedBannerActions": `TaskDetail-module__unclaimedBannerActions___fbYRt`,
	"followingBannerActions": `TaskDetail-module__followingBannerActions___ZREd_`,
	"claimButton": `TaskDetail-module__claimButton___AuLFq`,
	"claimButtonBreach": `TaskDetail-module__claimButtonBreach___Wv_CV`,
	"followButton": `TaskDetail-module__followButton___YD50W`,
	"unfollowButton": `TaskDetail-module__unfollowButton___EIk68`,
	"sectionHeader": `TaskDetail-module__sectionHeader___uGYNw`,
	"headerTop": `TaskDetail-module__headerTop___mUdWb`,
	"title": `TaskDetail-module__title___H5AXp`,
	"closeButton": `TaskDetail-module__closeButton___IrhIh`,
	"caption": `TaskDetail-module__caption___akEbw`,
	"taskDescription": `TaskDetail-module__taskDescription___MjbIn`,
	"badgesRow": `TaskDetail-module__badgesRow___TezKK`,
	"waitingStatusBadge": `TaskDetail-module__waitingStatusBadge___OAa6v`,
	"sectionInfo": `TaskDetail-module__sectionInfo___qfNKM`,
	"infoGrid": `TaskDetail-module__infoGrid___wD8HU`,
	"infoRow": `TaskDetail-module__infoRow___gsytr`,
	"infoLabel": `TaskDetail-module__infoLabel___M9DCK`,
	"infoValue": `TaskDetail-module__infoValue___C5B4S`,
	"athenaLinkWrap": `TaskDetail-module__athenaLinkWrap___GbZ6E`,
	"sectionEvidence": `TaskDetail-module__sectionEvidence___yEDgJ`,
	"sectionLabel": `TaskDetail-module__sectionLabel___ySsR2`,
	"evidenceMetaGrid": `TaskDetail-module__evidenceMetaGrid___wjM8A`,
	"evidenceCard": `TaskDetail-module__evidenceCard___oQa6e`,
	"evidenceHeader": `TaskDetail-module__evidenceHeader___PGN03`,
	"evidenceIcon": `TaskDetail-module__evidenceIcon___Tpi8r`,
	"evidenceLabel": `TaskDetail-module__evidenceLabel___WuCSN`,
	"evidenceSpacer": `TaskDetail-module__evidenceSpacer___Jw7SR`,
	"evidenceRef": `TaskDetail-module__evidenceRef___MDKDx`,
	"evidenceSummary": `TaskDetail-module__evidenceSummary___ZqYQK`,
	"evidenceSource": `TaskDetail-module__evidenceSource___d4_fe`,
	"sopSection": `TaskDetail-module__sopSection___xjbMt`,
	"linkedTasksSection": `TaskDetail-module__linkedTasksSection___dPunl`,
	"linkedTasksHeader": `TaskDetail-module__linkedTasksHeader___GcU4c`,
	"linkedTasksHeaderIcon": `TaskDetail-module__linkedTasksHeaderIcon___cQSHS`,
	"linkedTasksHeaderLabel": `TaskDetail-module__linkedTasksHeaderLabel___HpBno`,
	"linkedTasksHeaderChevron": `TaskDetail-module__linkedTasksHeaderChevron___ojWjX`,
	"linkedTasksHeaderChevronExpanded": `TaskDetail-module__linkedTasksHeaderChevronExpanded___B0PeM`,
	"linkedTasksList": `TaskDetail-module__linkedTasksList___DC3Bf`,
	"linkedTaskRow": `TaskDetail-module__linkedTaskRow___h0riB`,
	"linkedTaskTitle": `TaskDetail-module__linkedTaskTitle___VKwK8`,
	"linkedTaskMeta": `TaskDetail-module__linkedTaskMeta___uyW1M`,
	"linkedTaskOwner": `TaskDetail-module__linkedTaskOwner___g9CPN`,
	"linkedTaskDue": `TaskDetail-module__linkedTaskDue___wZrH9`,
	"subtasksSection": `TaskDetail-module__subtasksSection___hjwP6`,
	"subtasksHeader": `TaskDetail-module__subtasksHeader___XyKeH`,
	"subtasksHeaderAction": `TaskDetail-module__subtasksHeaderAction___MGvvj`,
	"subtasksList": `TaskDetail-module__subtasksList____xImD`,
	"subtaskRow": `TaskDetail-module__subtaskRow___ACxYH`,
	"subtaskRowCompleted": `TaskDetail-module__subtaskRowCompleted___uzJd1`,
	"subtaskRowCanceled": `TaskDetail-module__subtaskRowCanceled___q0LFC`,
	"subtaskStatusDot": `TaskDetail-module__subtaskStatusDot___DFKGh`,
	"subtaskStatusDotCompleted": `TaskDetail-module__subtaskStatusDotCompleted___fajup`,
	"subtaskStatusDotCanceled": `TaskDetail-module__subtaskStatusDotCanceled____gQnD`,
	"subtaskRowPrimary": `TaskDetail-module__subtaskRowPrimary___nSYfm`,
	"subtaskTitle": `TaskDetail-module__subtaskTitle___jFauS`,
	"subtaskTitleCompleted": `TaskDetail-module__subtaskTitleCompleted___GDBuI`,
	"subtaskTitleCanceled": `TaskDetail-module__subtaskTitleCanceled___d6ibn`,
	"subtaskMeta": `TaskDetail-module__subtaskMeta___Lp3DD`,
	"subtaskDue": `TaskDetail-module__subtaskDue___MgjVl`,
	"subtaskTeamIcon": `TaskDetail-module__subtaskTeamIcon___xb1IZ`,
	"subtaskRowMeta": `TaskDetail-module__subtaskRowMeta___DRJ9D`,
	"subtaskTeamWrap": `TaskDetail-module__subtaskTeamWrap___eRzKd`,
	"subtaskDueUrgent": `TaskDetail-module__subtaskDueUrgent___caCtc`,
	"subtaskTrashButton": `TaskDetail-module__subtaskTrashButton___Zj9fU`,
	"subtaskTrashButtonDisabled": `TaskDetail-module__subtaskTrashButtonDisabled___HYGH2`,
	"sopButton": `TaskDetail-module__sopButton___y6ipC`,
	"sopButtonDisabled": `TaskDetail-module__sopButtonDisabled___Pa2Jv`,
	"sopButtonIcon": `TaskDetail-module__sopButtonIcon___HDtLX`,
	"sopButtonLabel": `TaskDetail-module__sopButtonLabel___DttCU`,
	"sopButtonArrow": `TaskDetail-module__sopButtonArrow____jQJE`,
	"parentTaskSection": `TaskDetail-module__parentTaskSection___lbLaX`,
	"parentTaskCard": `TaskDetail-module__parentTaskCard___NPVLb`,
	"parentTaskIconWrap": `TaskDetail-module__parentTaskIconWrap___XnChB`,
	"parentTaskIcon": `TaskDetail-module__parentTaskIcon___hB4nN`,
	"parentTaskCopy": `TaskDetail-module__parentTaskCopy___EUGMt`,
	"parentTaskTitle": `TaskDetail-module__parentTaskTitle___sl_Fv`,
	"parentTaskSummary": `TaskDetail-module__parentTaskSummary___EUcvU`,
	"parentTaskMeta": `TaskDetail-module__parentTaskMeta___QooHR`,
	"parentTaskOwnerWrap": `TaskDetail-module__parentTaskOwnerWrap___doTjs`,
	"parentTaskOwnerBadge": `TaskDetail-module__parentTaskOwnerBadge___B6Vn1`,
	"parentTaskArrow": `TaskDetail-module__parentTaskArrow___o1i1P`,
	"assessmentSection": `TaskDetail-module__assessmentSection___TsgVY`,
	"assessmentBadgesRow": `TaskDetail-module__assessmentBadgesRow____zg6h`,
	"assessmentTypeBadge": `TaskDetail-module__assessmentTypeBadge___hhPMT`,
	"assessmentVariantBadge": `TaskDetail-module__assessmentVariantBadge___xhBx9`,
	"caregiverAssistedBadge": `TaskDetail-module__caregiverAssistedBadge___JNE5l`,
	"assessmentButton": `TaskDetail-module__assessmentButton___fre_O`,
	"assessmentButtonDisabled": `TaskDetail-module__assessmentButtonDisabled___YPr_a`,
	"assessmentButtonIcon": `TaskDetail-module__assessmentButtonIcon___tNO_n`,
	"assessmentButtonLabel": `TaskDetail-module__assessmentButtonLabel___JIgZA`,
	"assessmentButtonArrow": `TaskDetail-module__assessmentButtonArrow___iEAfK`,
	"sectionActions": `TaskDetail-module__sectionActions___bZ0yQ`,
	"primaryActionSection": `TaskDetail-module__primaryActionSection___EPr5z`,
	"primaryActionsRow": `TaskDetail-module__primaryActionsRow___CrIgJ`,
	"decisionActionsRow": `TaskDetail-module__decisionActionsRow___MIayQ`,
	"secondaryActionSection": `TaskDetail-module__secondaryActionSection___bUWVZ`,
	"secondaryActionSectionStandalone": `TaskDetail-module__secondaryActionSectionStandalone___M9mT1`,
	"cancelReasonPanel": `TaskDetail-module__cancelReasonPanel___c_Wby`,
	"cancelReasonInput": `TaskDetail-module__cancelReasonInput___JYV3l`,
	"cancelActionRow": `TaskDetail-module__cancelActionRow___Y17p5`,
	"cancelTaskAction": `TaskDetail-module__cancelTaskAction___hzd73`,
	"primaryAction": `TaskDetail-module__primaryAction___jWo7M`,
	"assessmentCompleteAction": `TaskDetail-module__assessmentCompleteAction___WMNjw`,
	"blockedIndicatorAction": `TaskDetail-module__blockedIndicatorAction___xPvsF`,
	"cancelTaskActionFullWidth": `TaskDetail-module__cancelTaskActionFullWidth___iW1Rp`,
	"secondaryAction": `TaskDetail-module__secondaryAction___Q7h19`,
	"secondaryActionsRow": `TaskDetail-module__secondaryActionsRow___akDaS`,
	"secondaryActionsRowClaimed": `TaskDetail-module__secondaryActionsRowClaimed___BSDTH`,
	"secondaryActionsGroup": `TaskDetail-module__secondaryActionsGroup___yIeXB`,
	"secondaryActionsStatusGroupClaimed": `TaskDetail-module__secondaryActionsStatusGroupClaimed___VdKae`,
	"statusActionWrap": `TaskDetail-module__statusActionWrap___q688q`,
	"blockDropdown": `TaskDetail-module__blockDropdown___TAMqT`,
	"blockDropdownItem": `TaskDetail-module__blockDropdownItem___x6C2y`,
	"escalateDropdown": `TaskDetail-module__escalateDropdown___eSL46`,
	"escalateDropdownLabel": `TaskDetail-module__escalateDropdownLabel___LMItM`,
	"escalateTargetOptions": `TaskDetail-module__escalateTargetOptions___OwQN3`,
	"escalateTargetOption": `TaskDetail-module__escalateTargetOption___GPXS3`,
	"escalateTargetOptionActive": `TaskDetail-module__escalateTargetOptionActive___K94Li`,
	"escalateReasonInput": `TaskDetail-module__escalateReasonInput___aFuAN`,
	"escalateSubmitButton": `TaskDetail-module__escalateSubmitButton___XjcI5`,
	"alertAction": `TaskDetail-module__alertAction___R0zuF`,
	"statusActionLabel": `TaskDetail-module__statusActionLabel____Cpk6`
};
module.exports = ___CSS_LOADER_EXPORT___;
